declare var require: any;
export const environment = {
  test: false,
  stage: true,
  production: false,
  app: {
    name: 'Bockmann',
    version: require('../../package.json').version,
  },
  serverUrl: 'https://boeckmann-configurator-backend-stage.azurewebsites.net',
};
